const API_BASE = "https://reference-app.bedfordprecision.com/api/quick-order-pad";
  
let rowCounter = 0;
const searchTimeouts = new Map();
const productCache = new Map();
const dropdownState = new Map();

const getPlaceholderImage = () => {
  const container = document.querySelector('#orderRows');
  return container?.dataset?.placeholderImage;
};

const isB2B = window.isB2B === true || document.documentElement.dataset.b2b === "true";

const toNumber = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = typeof v === "number" ? v : parseFloat(String(v).replace(/[^\d.]/g, ""));
  return Number.isFinite(n) ? n : null;
};

const formatMoney = (amount) => {
  if (amount === null || amount === undefined) return "$0.00";
  return `$${Number(amount).toFixed(2)}`;
};

const fetchJSON = async (url, opts = {}) => {
  const res = await fetch(url, {
    credentials: "same-origin",
    headers: {
      "Accept": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Pragma": "no-cache",
      ...(opts.headers || {})
    },
    cache: "no-store",
    ...opts
  });
  if (!res.ok) throw new Error(`Request failed: ${res.status}`);
  return res.json();
};

const ensureCartCountBadge = () => {
  const wrap = document.querySelector(".head-slot-cart-link .head-slot-cart-link-wrap");
  if (!wrap) return null;

  let badge = wrap.querySelector(".head-slot-cart-link-quantity");
  if (!badge) {
    badge = document.createElement("span");
    badge.className = "head-slot-cart-link-quantity";
    wrap.appendChild(badge);
  }
  return badge;
};

const setCartCount = (count) => {
  const mainBadge = ensureCartCountBadge();
  if (mainBadge) {
    mainBadge.textContent = String(count);
    mainBadge.classList.toggle("hidden", count === 0);
    mainBadge.classList.toggle("is-empty", count === 0);
    if (count > 0) {
      mainBadge.removeAttribute("aria-hidden");
    } else {
      mainBadge.setAttribute("aria-hidden", "true");
    }
  }

  const others = document.querySelectorAll("[data-cart-count], .cart-count-bubble .text, .cart-count, .header-cart-count");
  others.forEach(el => {
    el.textContent = String(count);
    el.setAttribute("data-cart-count", String(count));
    el.classList.toggle("hidden", count === 0);
    el.classList.toggle("is-empty", count === 0);
    if (count > 0) {
      el.removeAttribute("aria-hidden");
    } else {
      el.setAttribute("aria-hidden", "true");
    }
  });
};

const toggleMiniCartEmptyState = (itemCount) => {
  const mini = document.querySelector("mini-cart");
  if (mini) {
    mini.classList.toggle("is-empty", (itemCount ?? 0) === 0);
  }
};

const refreshMiniCartSections = async () => {
  const sectionsUrlBase = document.documentElement?.dataset?.sectionsUrl || "/";
  const params = `?sections=header-mini-cart-content,header-mini-cart-footer&t=${Date.now()}`;
  let htmlBySection = {};
  try {
    htmlBySection = await fetchJSON(sectionsUrlBase + params);
  } catch {
    return;
  }

  const contentEl = document.querySelector("#header-mini-cart-content");
  const footerEl = document.querySelector("#header-mini-cart-footer");

  if (contentEl && htmlBySection["header-mini-cart-content"]) {
    contentEl.innerHTML = htmlBySection["header-mini-cart-content"];
  }
  if (footerEl && htmlBySection["header-mini-cart-footer"]) {
    footerEl.innerHTML = htmlBySection["header-mini-cart-footer"];
  }
};

const refreshCartUI = async () => {
  const cart = await fetchJSON(`/cart.js?t=${Date.now()}`);
  const count = cart?.item_count ?? 0;
  setCartCount(count);
  toggleMiniCartEmptyState(count);
  return cart;
};

const openMiniCart = () => {
  const miniCart = document.querySelector("mini-cart");
  if (miniCart) {
    if (typeof miniCart.open === 'function') {
      miniCart.open();
    } else {
      miniCart.classList.add('active', 'open');
    }
    
    const cartLink = document.querySelector('.head-slot-cart-link');
    if (cartLink && typeof cartLink.click === 'function') {
      cartLink.click();
    }
  }
};

const searchProducts = async (query, limit = 20) => {
  if (!query || query.length < 2) {
    return { data: [], total: 0 };
  }

  try {
    const url = `${API_BASE}/search?q=${encodeURIComponent(query)}&limit=${limit}&page=1`;
    const response = await fetch(url, {
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (!response.ok) {
      throw new Error(`Search failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Search error:', error);
    return { data: [], total: 0 };
  }
};

const createRow = () => {
  rowCounter++;
  const rowId = `row-${rowCounter}`;

  const row = document.createElement('div');
  row.className = 'order-row';
  row.dataset.rowId = rowId;
  row.innerHTML = `
    <div class="part-number-cell">
      <div class="search-input-wrapper">
        <input 
          type="text" 
          class="part-search-input" 
          placeholder="Search Bedford or OEM SKU"
          data-row-id="${rowId}"
        >
        <div class="search-dropdown" data-row-id="${rowId}"></div>
      </div>
      <div class="selected-product" style="display: none;" data-row-id="${rowId}"></div>
    </div>
    <div class="price-cell" data-row-id="${rowId}">-</div>
    <div class="qty-cell">
      <div class="qty-control">
        <button type="button" class="qty-btn qty-dec" data-row-id="${rowId}">-</button>
        <input type="number" class="qty-input" value="1" min="1" data-row-id="${rowId}">
        <button type="button" class="qty-btn qty-inc" data-row-id="${rowId}">+</button>
      </div>
    </div>
    <div class="total-cell" data-row-id="${rowId}"><span>-</span></div>
    <div class="action-cell">
      <button type="button" class="delete-btn" data-row-id="${rowId}" title="Remove">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 11V17" stroke="#DE2307" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 11V17" stroke="#DE2307" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6" stroke="#DE2307" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 6H21" stroke="#DE2307" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#DE2307" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;

  return row;
};

const getProductPrice = (product) => {
  const catalogPrice = toNumber(product.catalog_price);
  const variantPrice = toNumber(product.variant_price);
  return (isB2B && catalogPrice !== null) ? catalogPrice : variantPrice;
};

const handleSearchInput = (input) => {
  const rowId = input.dataset.rowId;
  const query = input.value.trim();
  const dropdown = document.querySelector(`.search-dropdown[data-row-id="${rowId}"]`);

  document.querySelectorAll('.search-dropdown').forEach(dd => {
    if (dd.dataset.rowId !== rowId) {
      dd.classList.remove('active');
      dd.innerHTML = '';
      dropdownState.delete(dd.dataset.rowId);
    }
  });

  if (searchTimeouts.has(rowId)) {
    clearTimeout(searchTimeouts.get(rowId));
  }

  if (query.length < 2) {
    dropdown.classList.remove('active');
    dropdown.innerHTML = '';
    dropdownState.delete(rowId);
    return;
  }

  dropdown.innerHTML = '<div class="dropdown-loading">Searching...</div>';
  dropdown.classList.add('active');

  const timeoutId = setTimeout(async () => {
    try {
      const results = await searchProducts(query);
      
      if (results.data.length === 0) {
        dropdown.innerHTML = '<div class="dropdown-no-results">No products found</div>';
        dropdownState.delete(rowId);
      } else {
        const sortedData = [...results.data].sort((a, b) => {
          const aHasOEM = (a.replacements?.length || 0) > 0;
          const bHasOEM = (b.replacements?.length || 0) > 0;
          
          if (aHasOEM && !bHasOEM) return -1;
          if (!aHasOEM && bHasOEM) return 1;
          
          const aHasImage = !!a.product_image;
          const bHasImage = !!b.product_image;
          if (aHasImage && !bHasImage) return -1;
          if (!aHasImage && bHasImage) return 1;
          
          return 0;
        });

        dropdownState.set(rowId, {
          products: sortedData,
          selectedIndex: -1
        });

        dropdown.innerHTML = sortedData.map((item, index) => {
          const itemId = `${rowId}-item-${index}`;
          productCache.set(itemId, item);
          
          const replacements = item.replacements || [];
          const oemText = replacements.length > 0 
            ? `OEM: ${replacements.map(r => r.sku).join(', ')}`
            : '';

          const price = getProductPrice(item);
          const priceDisplay = price !== null ? formatMoney(price) : 'N/A';

          return `
            <div class="search-dropdown-item" data-row-id="${rowId}" data-item-id="${itemId}" data-index="${index}">
              ${item.product_image 
                ? `<img src="${item.product_image}" class="dropdown-item-image" alt="${item.product_title}">`
                : `<img src="${getPlaceholderImage()}" class="dropdown-item-image" alt="No image available">`
              }
              <div class="dropdown-item-info">
                <div class="dropdown-item-title">${item.product_title}</div>
                <div class="dropdown-item-sku">SKU: ${item.variant_sku}</div>
                ${oemText ? `<div class="dropdown-item-oem">${oemText}</div>` : ''}
              </div>
              <div class="dropdown-item-price">${priceDisplay}</div>
            </div>
          `;
        }).join('');
      }
    } catch (error) {
      console.error('Search error:', error);
      dropdown.innerHTML = '<div class="dropdown-no-results">Search failed. Please try again.</div>';
      dropdownState.delete(rowId);
    }
  }, 300);
  
  searchTimeouts.set(rowId, timeoutId);
};

const highlightDropdownItem = (rowId, index) => {
  const dropdown = document.querySelector(`.search-dropdown[data-row-id="${rowId}"]`);
  if (!dropdown) return;

  const items = dropdown.querySelectorAll('.search-dropdown-item');
  items.forEach((item, i) => {
    item.classList.toggle('highlighted', i === index);
  });

  if (index >= 0 && items[index]) {
    items[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
};

const handleDropdownNavigation = (input, key) => {
  const rowId = input.dataset.rowId;
  const state = dropdownState.get(rowId);
  
  if (!state || !state.products || state.products.length === 0) return false;

  if (key === 'ArrowDown') {    
    state.selectedIndex = Math.min(state.selectedIndex + 1, state.products.length - 1);
    highlightDropdownItem(rowId, state.selectedIndex);
    return true;
  } else if (key === 'ArrowUp') {
    state.selectedIndex = Math.max(state.selectedIndex - 1, -1);
    highlightDropdownItem(rowId, state.selectedIndex);
    return true;
  } else if (key === 'Enter' || key === 'Tab') {
    if (state.selectedIndex >= 0) {
      const product = state.products[state.selectedIndex];
      if (product) {
        selectProduct(rowId, product);
        const row = document.querySelector(`.order-row[data-row-id="${rowId}"]`);
        const qtyInput = row?.querySelector('.qty-input');
        if (qtyInput) {
          setTimeout(() => {
            qtyInput.focus();
            qtyInput.select();
          }, 0);
        }
        return true;
      }
    }
  }
  return false;
};

const selectProduct = (rowId, product) => {
  const row = document.querySelector(`.order-row[data-row-id="${rowId}"]`);
  if (!row) return;

  productCache.set(rowId, product);

  const searchWrapper = row.querySelector('.search-input-wrapper');
  const selectedDiv = row.querySelector('.selected-product');
  const dropdown = row.querySelector('.search-dropdown');

  searchWrapper.style.display = 'none';
  dropdown.classList.remove('active');
  dropdownState.delete(rowId);

  const replacements = product.replacements || [];
  const oemText = replacements.length > 0 
    ? `<div class="selected-product-oem">OEM: ${replacements.map(r => r.sku).join(', ')}</div>`
    : '';

  selectedDiv.innerHTML = `
    <a href="${product.product_url}" target="_blank">
      ${product.product_image 
        ? `<img src="${product.product_image}" class="selected-product-image" alt="${product.product_title}">`
        : `<img src="${getPlaceholderImage()}" class="selected-product-image" alt="No image available">`
      }
    </a>
    <div class="selected-product-info">
      <a href="${product.product_url}" target="_blank" class="selected-product-title">${product.product_title}</a>
      <div class="selected-product-sku">SKU: ${product.variant_sku}</div>
      ${oemText}
    </div>
  `;
  selectedDiv.style.display = 'flex';

  updateRowPrice(rowId);
};

const updateRowPrice = (rowId) => {
  const row = document.querySelector(`.order-row[data-row-id="${rowId}"]`);
  if (!row) return;

  const product = productCache.get(rowId);
  if (!product) return;

  const qtyInput = row.querySelector('.qty-input');
  let quantity = parseInt(qtyInput.value);
  
  if (isNaN(quantity) || quantity < 1) {
    quantity = 1;
  }

  const priceToUse = getProductPrice(product);

  const priceCell = row.querySelector('.price-cell');
  const totalCell = row.querySelector('.total-cell span');

  if (priceToUse !== null) {
    priceCell.textContent = formatMoney(priceToUse);
    totalCell.textContent = formatMoney(priceToUse * quantity);
  } else {
    priceCell.textContent = 'N/A';
    totalCell.textContent = 'N/A';
  }

  updateFooterTotals();
};

const updateFooterTotals = () => {
  const rows = document.querySelectorAll('.order-row');
  let partsCount = 0;
  let totalItems = 0;
  let totalAmount = 0;

  rows.forEach(row => {
    const rowId = row.dataset.rowId;
    const product = productCache.get(rowId);
    if (!product) return;

    const qtyInput = row.querySelector('.qty-input');
    const quantity = parseInt(qtyInput.value) || 1;

    const priceToUse = getProductPrice(product);

    if (priceToUse !== null) {
      partsCount++;
      totalItems += quantity;
      totalAmount += priceToUse * quantity;
    }
  });

  const itemsCountEl = document.querySelector('#itemsCount');
  const totalPriceEl = document.querySelector('#totalPrice');
  const addAllBtn = document.querySelector('#addAllToCartBtn');
  
  if (itemsCountEl) {
    if (partsCount === 0) {
      itemsCountEl.textContent = '0 items ready to add';
    } else if (partsCount === 1 && totalItems === 1) {
      itemsCountEl.textContent = '1 part, 1 item ready to add';
    } else if (partsCount === 1) {
      itemsCountEl.textContent = `1 part, ${totalItems} items ready to add`;
    } else {
      itemsCountEl.textContent = `${partsCount} parts, ${totalItems} items ready to add`;
    }
  }
  
  if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalAmount);
  if (addAllBtn) addAllBtn.disabled = partsCount === 0;
};

const deleteRow = (rowId) => {
  const row = document.querySelector(`.order-row[data-row-id="${rowId}"]`);
  if (!row) return;
  
  productCache.delete(rowId);
  dropdownState.delete(rowId);
  row.remove();  
  updateFooterTotals();

  const remainingRows = document.querySelectorAll('.order-row');
  if (remainingRows.length === 0) {
    addNewRow();
  }
};

const addNewRow = () => {
  const container = document.querySelector('#orderRows');
  if (!container) return;
  
  const row = createRow();
  container.appendChild(row);
  updateFooterTotals();
};

const addAllToCart = async () => {
  const rows = document.querySelectorAll('.order-row');
  const items = [];

  rows.forEach(row => {
    const rowId = row.dataset.rowId;
    const product = productCache.get(rowId);
    if (!product) return;

    const qtyInput = row.querySelector('.qty-input');
    let quantity = parseInt(qtyInput.value);
    
    if (isNaN(quantity) || quantity < 1) {
      return;
    }

    if (product.variant_id) {
      const numericId = parseInt((product.variant_id.match(/\d+$/)?.[0] || product.variant_id), 10);
      if (numericId) {
        items.push({ id: numericId, quantity });
      }
    }
  });

  if (items.length === 0) {
    return;
  }

  const addAllBtn = document.querySelector('#addAllToCartBtn');
  if (!addAllBtn) return;
  
  addAllBtn.disabled = true;
  const originalText = addAllBtn.textContent;
  addAllBtn.textContent = 'Adding...';

  try {
    for (const item of items) {
      const formData = new FormData();
      formData.append("id", String(item.id));
      formData.append("quantity", String(item.quantity));

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        credentials: "same-origin",
        headers: { 
          "Accept": "application/json", 
          "X-Requested-With": "XMLHttpRequest" 
        },
        cache: "no-store"
      });

      if (!addRes.ok) {
        let message = "Failed to add item to cart.";
        try {
          const errJson = await addRes.json();
          message = errJson?.description || errJson?.message || message;
        } catch {}
        throw new Error(message);
      }
    }

    const cart = await refreshCartUI();
    await refreshMiniCartSections();
    
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    
    openMiniCart();
    
    const container = document.querySelector('#orderRows');
    if (container) {
      container.innerHTML = '';
      productCache.clear();
      dropdownState.clear();
      rowCounter = 0;
      
      for (let i = 0; i < 5; i++) {
        addNewRow();
      }
      
      updateFooterTotals();
    }

  } catch (error) {
    console.error('Add to cart error:', error);
  } finally {
    if (addAllBtn) {
      addAllBtn.disabled = false;
      addAllBtn.textContent = originalText;
    }
    updateFooterTotals();
  }
};

const initializeEventListeners = () => {
  const container = document.querySelector('#orderRows');
  const addRowBtn = document.querySelector('#addRowBtn');
  const addAllBtn = document.querySelector('#addAllToCartBtn');

  if (!container) return;

  for (let i = 0; i < 5; i++) {
    addNewRow();
  }

  container.addEventListener('input', (e) => {
    if (e.target.classList.contains('part-search-input')) {
      handleSearchInput(e.target);
    } else if (e.target.classList.contains('qty-input')) {
      const rowId = e.target.dataset.rowId;
      updateRowPrice(rowId);
    }
  });
  
  container.addEventListener('blur', (e) => {
    if (e.target.classList.contains('qty-input')) {
      let value = parseInt(e.target.value);
      if (isNaN(value) || value < 1) {
        e.target.value = 1;
        const rowId = e.target.dataset.rowId;
        updateRowPrice(rowId);
      }
    }
  }, true);

  container.addEventListener('mousedown', (e) => {
    const qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      e.preventDefault();
    }
  });

  container.addEventListener('click', (e) => {
    const dropdownItem = e.target.closest('.search-dropdown-item');
    if (dropdownItem) {
      const rowId = dropdownItem.dataset.rowId;
      const itemId = dropdownItem.dataset.itemId;
      const product = productCache.get(itemId);
      if (product) {
        selectProduct(rowId, product);
        productCache.delete(itemId);
      }
      return;
    }

    const qtyDec = e.target.closest('.qty-dec');
    if (qtyDec) {
      const rowId = qtyDec.dataset.rowId;
      const input = container.querySelector(`.qty-input[data-row-id="${rowId}"]`);
      if (input) {
        let currentVal = parseInt(input.value);
        if (isNaN(currentVal) || currentVal < 1) {
          currentVal = 1;
        }
        input.value = Math.max(1, currentVal - 1);
        updateRowPrice(rowId);
      }
      return;
    }

    const qtyInc = e.target.closest('.qty-inc');
    if (qtyInc) {
      const rowId = qtyInc.dataset.rowId;
      const input = container.querySelector(`.qty-input[data-row-id="${rowId}"]`);
      if (input) {
        let currentVal = parseInt(input.value);
        if (isNaN(currentVal) || currentVal < 0) {
          currentVal = 0;
        }
        input.value = currentVal + 1;
        updateRowPrice(rowId);
      }
      return;
    }

    const deleteBtn = e.target.closest('.delete-btn');
    if (deleteBtn) {
      const rowId = deleteBtn.dataset.rowId;
      deleteRow(rowId);
      return;
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.search-input-wrapper')) {
      document.querySelectorAll('.search-dropdown').forEach(dropdown => {
        dropdown.classList.remove('active');
        const rowId = dropdown.dataset.rowId;
        if (rowId) {
          dropdownState.delete(rowId);
        }
      });
    }
  });

  container.addEventListener('keydown', (e) => {
    const searchInput = e.target.closest('.part-search-input');
    
    if (searchInput) {
      const rowId = searchInput.dataset.rowId;
      const dropdown = document.querySelector(`.search-dropdown[data-row-id="${rowId}"]`);
      
      if (dropdown && dropdown.classList.contains('active')) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          handleDropdownNavigation(searchInput, e.key);
          return;
        } else if (e.key === 'Enter') {
          e.preventDefault();
          const handled = handleDropdownNavigation(searchInput, e.key);
          if (handled) return;
        } else if (e.key === 'Tab') {
          const handled = handleDropdownNavigation(searchInput, e.key);
          if (handled) {
            e.preventDefault();
            return;
          }
        }
      }
      
      if (e.key === 'Tab' && !dropdown?.classList.contains('active')) {
        const row = document.querySelector(`.order-row[data-row-id="${rowId}"]`);
        const qtyInput = row?.querySelector('.qty-input');

        if (qtyInput) {
          e.preventDefault();
          qtyInput.focus();
          qtyInput.select();
        }
        return;
      }
    }

    if (e.key === 'Tab' && e.target.classList.contains('qty-input')) {
      const currentRow = e.target.closest('.order-row');
      const allRows = Array.from(document.querySelectorAll('.order-row'));
      const currentIndex = allRows.indexOf(currentRow);

      if (currentIndex < allRows.length - 1) {
        e.preventDefault();
        const nextRow = allRows[currentIndex + 1];          
        const nextRowId = nextRow.dataset.rowId;
        const nextProduct = productCache.get(nextRowId);
        
        if (nextProduct) {
          const nextQtyInput = nextRow?.querySelector('.qty-input');
          if (nextQtyInput) {
            nextQtyInput.focus();
            nextQtyInput.select();
          }
        } else {
          const nextSearchInput = nextRow?.querySelector('.part-search-input');
          if (nextSearchInput) {
            nextSearchInput.focus();
          }
        }
      }
    }
  });

  addRowBtn?.addEventListener('click', addNewRow);
  addAllBtn?.addEventListener('click', addAllToCart);

  ensureCartCountBadge();
  refreshCartUI().catch(() => {});
};

initializeEventListeners();